import { render } from "./App.vue?vue&type=template&id=dbd4243e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=dbd4243e&lang=css"

import exportComponent from "/opt/jenkins/workspace/ops-pipeline/pc-bms-official/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__